import React from 'react';
import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
//import image from './Pages/img/1920.jpg'

import { BrowserRouter as Router } from "react-router-dom";
import Routes from './Routes';
import Main from './Pages/Student/Main';
//import Login from './Pages/Student/Login';

//const pp = 1;
//const { user1,pass } = this.props.match.params
console.log("sds");
function App() {
  return (
    // <div style={{ backgroundImage:`url(${image})`,  backgroundRepeat: 'no-repeat',  backgroundSize: 'cover' }}>
         <div >
      <Router >

            {localStorage.getItem('name') === null  ?<><Routes/></>:<>
             <Main />
            </> }
            {/* <Routes /> */}
      
           {console.log(localStorage.getItem('nameuser'))} 
      </Router>
</div>
  

  );
}
export default App;
